module.exports = __webpack_public_path__ + "static/media/ge.63b03114.svg";